<template>
  <div class="xrMultiParamAdd">
    <el-form ref="dataForm" id="dataForm" :model="temp" label-suffix="：">
      <el-row :gutter="15" v-for="(item,index) in temp.columnList" :key="index">
        <el-col v-for="(formItem, formIndex) in formArr" :span="formItem.span" :key="formIndex">
          <el-form-item :label-width="formItem.labelWidth"  :label="formItem.text">
            <el-input v-model="item[formItem.field]" :title="formItem.field"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <i style="color: #518de6;cursor: pointer;font-size: 20px;margin-top: 5px;margin-left: 10px" class="el-icon-remove-outline" @click="delColumn(index)"></i>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <el-button type="primary" @click="addOne">增加一列</el-button>
        </el-col>
      </el-row>

    </el-form>

  </div>
</template>

<script>
import TemplateItem from "../template/common/template-item.vue";

export default {
  name: 'XrMultiParamAdd',
  props: ['value', 'formArr'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      list: [],
      temp: {
        columnList: []
      }
    }
  },
  watch: {
    value(newValue) {
      if(newValue == null || newValue == undefined){
        newValue = '';
      }
      try {
        this.temp.columnList = JSON.parse(newValue);;
      } catch (error) {
        this.temp.columnList = [];
      }
    },
    'temp.columnList': {
      deep: true,
      handler(arr) {
        let newValue = JSON.stringify(arr);
        this.$emit('change', newValue);
      }
    }
  },
  components: {
    TemplateItem
  },
  methods: {
    //添加一行
    addOne(){
      let obj = new Object();
      let formArr = this.formArr;
      for(let i = 0; i < formArr.length; i ++){
        obj[formArr[i]['field']] = '';
      }
      this.temp.columnList.push(obj);
    },
    //【数据列】删除一行
    delColumn(index){
      this.temp.columnList.splice(index,1)
    },
  }
}
</script>
<style scoped>
  .xrMultiParamAdd{}
  .xrMultiParamAdd .el-form-item{margin: 0px 10px !important;}
  .xrMultiParamAdd .el-row{}
  .xrMultiParamAdd .el-row .el-col{margin-bottom: 10px;}
</style>




// WEBPACK FOOTER //
// src/components/XrMultiParamAdd/index.vue